import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { UserListItem, UserAccessOrganization, UserProfile, User, IUserRole, IUserLog } from "interface/user";
import { FilterOption } from "interface";
import { IUserProfileVessel } from "interface/vessel";
import { IProduct } from "interface/product";
import { IBuyer } from "interface/buyer";
import { AlertMessage } from "interface/alert";

export interface UserListFilter extends FilterOption {
    firstname?: string
    lastname?: string,
    email?: string,
    vessel?: string,
    buyer?: string,
    terminal?: string,
    role?: string,
    roleId?: string
}

export interface HeaderFilter {
    vesselLedgerAccountNumber?: string,
    vesselHullId?: number,
    vesselName?: string,
    vesselId?: string

    terminalCode?: string,
    terminalName?: string,

    buyerLedgerAccountNumber?: number,
    buyerName?: string,
}

// export async function getUserAccessBuyersApi() {
//     const apiUri = "User/AccessBuyers"

//     try {
//         const registrations = await AxiosApi.get<ApiResponse<UserAccessItem[]>>(apiUri, )

//         return registrations.data
//     } catch (error) {
//         throw error
//     }
// }


export async function getUserInformationApi() {
    const apiUri = "User/Information"

    try {
        const registrations = await AxiosApi.get<ApiResponse<any>>(apiUri, )

        return registrations.data
    } catch (error) {
        throw error
    }
}

export async function updateTwoFactorSendTypeApi(data: {
    id:number,
    name: string
}) {
    const apiUri = "User/TwoFactorSendType"

    try {
        const registrations = await AxiosApi.patch<ApiResponse<UserProfile>>(apiUri, data )

        return registrations.data
    } catch (error) {
        throw error
    }
}

export async function getUserProfileApi() {
    const apiUri = "User/profile"

    try {
        const registrations = await AxiosApi.get<ApiResponse<UserProfile>>(apiUri, )

        return registrations.data
    } catch (error) {
        throw error
    }
}


export async function getUserVesselsApi() {
    const apiUri = "User/Vessels"

    try {
        const registrations = await AxiosApi.get<ApiResponse<IUserProfileVessel[]>>(apiUri, )

        return registrations.data
    } catch (error) {
        throw error
    }
}



export async function getUserSearchSpeciesApi(text:string) {
    const apiUri = "User/SearchProfileSpecies"

    try {
        const registrations = await AxiosApi.get<ApiResponse<IProduct[]>>(apiUri, { params: { text } })

        return registrations.data.data
    } catch (error) {
        throw error
    }
}

export async function updateVesselSmsInfoApi(data: { prefix: string, number: string, vesselId: string }) {
    const apiUri = "User/UpdateVesselSmsInfo"

    try {
        const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data)

        return registrations.data
    } catch (error) {
        throw error
    }
}


export async function getUserOrganizationsApi() {
    const apiUri = "User/Organizations"

    try {
        const registrations = await AxiosApi.get<ApiResponse<UserAccessOrganization[]>>(apiUri,)

        return registrations.data
    } catch (error) {
        console.log('error', error);
        throw error
    }
}

export async function getUserDefaultOrganizationApi() {
    const apiUri = "User/DefaultOrganization"

    try {
        const defaultOrg = await AxiosApi.get<ApiResponse<UserAccessOrganization>>(apiUri,)

        return defaultOrg.data
    } catch (error) {
        throw error
    }
}

export async function saveUserDefaultOrganizationApi(org: UserAccessOrganization | null) {
    const apiUri = "User/SaveDefaultOrganization"

    try {
        const response = await AxiosApi.post<ApiResponse<any>>(apiUri, org)

        return response.data
    } catch (error) {
        throw error
    }
}

export async function getUserListApi(filter: UserListFilter) {
    const apiUri = "User/UserList"
    try {
        const userList = await AxiosApi.get<ApiResponse<UserListItem[]>>(apiUri, {
            params: filter
        })
        return userList.data
    } catch (error) {
        throw error
    }
}

export async function  setNotificationSetting(data: { notificationMethodId: string, notificationEventId: string }) {
    const apiUri = "User/SetNotificationSetting"

    try {
        const response = await AxiosApi.post<ApiResponse<any>>(apiUri, data)

        return response.data
    } catch (error) {
        throw error
    }
}

export async function  allUsersGroupRolesApi() {
    const apiUri = "User/UsersGroup"

    try {
        const response = await AxiosApi.get<ApiResponse<IUserRole[]>>(apiUri)
        console.log('allUsersGroupRolesApi response', response.data);
        return response.data
    } catch (error) {
        throw error
    }
}



export async function userProfileBuyersApi() {
    const apiUri = "User/UserProfileBuyers"

    try {
        const response = await AxiosApi.get<ApiResponse<IBuyer[]>>(apiUri, )

        return response.data
    } catch (error) {
        throw error
    }
}

export async function getAlertsApi({ terminalId, vesselLedgerAccount, buyerLedgerAccount }: { terminalId?: number, vesselLedgerAccount?: string, buyerLedgerAccount?: string }) {
    const apiUri = "User/Alerts"

    try {
        const response = await AxiosApi.get<ApiResponse<AlertMessage[]>>(apiUri, { params: { terminalId, vesselLedgerAccount, buyerLedgerAccount } })

        return response.data
    } catch (error) {
        throw error
    }
}
